var _rect, _rect2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "url(#paint0_linear_6_22596)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "url(#paint1_linear_6_22596)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5996 19.4002C14.5996 14.7201 18.3197 11 22.9998 11C27.6799 11 31.3999 14.7201 31.3999 19.4002C31.3999 24.0803 22.9998 31.4004 22.9998 31.4004C22.9998 31.4004 14.5996 24.0803 14.5996 19.4002ZM19.3997 19.4002C19.3997 21.4402 20.9597 23.0002 22.9998 23.0002C25.0398 23.0002 26.5998 21.4402 26.5998 19.4002C26.5998 17.3601 25.0398 15.8001 22.9998 15.8001C20.9597 15.8001 19.3997 17.3601 19.3997 19.4002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3204 26.3604C30.8004 25.7603 31.2804 25.0403 31.6404 24.3203C33.8004 25.4003 35.0005 26.9604 35.0005 28.8804C35.0005 32.4805 30.2004 35.0005 23.0002 35.0005C15.8001 35.0005 11 32.4805 11 28.8804C11 26.9604 12.2 25.4003 14.3601 24.3203C14.615 24.8302 14.9302 25.28 15.2629 25.7547C15.4 25.9504 15.54 26.1503 15.6801 26.3604C14.2401 26.9604 13.4 27.9204 13.4 28.7604C13.4 30.5604 17.0001 32.4805 23.0002 32.4805C26.4803 32.4805 32.6004 31.5205 32.6004 28.7604C32.6004 27.9204 31.7604 27.0804 30.3204 26.3604Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_22596",
    x1: 23,
    y1: 26.895,
    x2: 23,
    y2: 0.992272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050D42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_22596",
    x1: 0,
    y1: 23,
    x2: 46,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.6d3434085805cb88785489e1593a6eab.svg";
export { ForwardRef as ReactComponent };